import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getApi } from "../../services/api/globalApi";
import CategoriesSelect from "../../components/common/inputs/CategoriesSelect";
import { utilsState } from "../../sotre/redux/features/utilsSlice";

export default function ProductFilter({ filter, filterDataHandler }) {
  const [categoryData, setCategoryData] = useState([]);
  const { utils } = useSelector(utilsState);
  const [initialCategories] = useState(() =>
    (filter?.categories || []).map((_id) => ({ _id }))
  );

  const getCategory = async (params) => {
    const path = "admin/categories/withoutPaginate";
    try {
      const response = await getApi({ path, params: { ...params } });
      setCategoryData(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCategory({});
  }, []);

  const filterCategory = (data) => {
    filterDataHandler({ page: 1, categories: data });
  };

  return (
    <div className="w-full flex flex-col flex-wrap my-8 gap-6 px-6">
      <div className="w-full flex flex-col sm:flex-row gap-6">
        <div className="w-full sm:w-4/12">
          <div className="max-w-md mx-auto">
            <label
              htmlFor="default-search"
              className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
            >
              Search
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
              <input
                value={filter?.name || ""}
                onChange={(e) =>
                  filterDataHandler({ page: 1, name: e.target.value })
                }
                type="search"
                className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="جست و جو محصول ..."
                required
              />
            </div>
          </div>
        </div>
        <div className="w-full sm:w-4/12">
          <CategoriesSelect
            oldCategory={initialCategories}
            onChange={filterCategory}
          />
        </div>
        <div className="w-full sm:w-4/12">
          <select
            value={filter?.inventoryStatus || ""}
            onChange={(e) =>
              filterDataHandler({ page: 1, inventoryStatus: e.target.value })
            }
            id="province"
            className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option value="">وضعیت موجودی</option>
            {utils
              ? utils.IVENTORY_STATUSE_VALUES.map((item) => (
                  <option key={item.value} value={item.value}>{item?.name}</option>
                ))
              : null}
          </select>
        </div>
      </div>
    </div>
  );
}
